import { render, staticRenderFns } from "./UserPhoto.vue?vue&type=template&id=7325de88&scoped=true&"
import script from "./UserPhoto.vue?vue&type=script&lang=js&"
export * from "./UserPhoto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7325de88",
  null
  
)

export default component.exports